import { cn } from '../lib/cn';

/**
 * The total, always carrying its band: `58 ± 5`, never naked (§4).
 * One numeric scale out of 100, plus the level name. No percentage sign.
 */
export function ScoreDial({
  total,
  plusMinus,
  level,
  levelName,
  previousTotal,
}: {
  total: number | null;
  plusMinus: number;
  level: number | null;
  levelName: string;
  previousTotal: number | null;
}) {
  const delta = total !== null && previousTotal !== null ? total - previousTotal : null;

  return (
    <div className="flex flex-col items-center text-center">
      <div className="flex items-baseline gap-1.5">
        <span className="text-6xl font-bold leading-none text-gray-900 tabular-nums">
          {total ?? '—'}
        </span>
        {total !== null && (
          <span className="text-2xl font-medium text-gray-400 tabular-nums">± {plusMinus}</span>
        )}
      </div>
      <div className="mt-3 flex items-center gap-2">
        <span className="rounded-full bg-blue-50 px-3 py-1 text-sm font-semibold text-blue-700">
          {level !== null ? `Level ${level}` : 'Not scored'} · {levelName}
        </span>
      </div>
      {delta !== null && (
        <p className={cn('mt-2 text-sm font-medium', delta >= 0 ? 'text-emerald-700' : 'text-rose-700')}>
          {delta >= 0 ? '▲' : '▼'} {Math.abs(delta)} since last check
        </p>
      )}
      {delta === null && previousTotal === null && (
        <p className="mt-2 text-sm text-gray-400">Your first check</p>
      )}
    </div>
  );
}
